import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AppConfigService } from '../config/app-config.service';
import { TenantContextService } from './tenant-context.service';

/**
 * Header de CORRELACIÓN de tenant (`X-Tenant-Id`).
 *
 * IMPORTANTE: NO es autoridad de seguridad — el backend deriva el tenant del JWT
 * firmado. Este header sirve para (a) trazabilidad/observabilidad server-side y
 * (b) impersonación explícita del super-admin, que el backend valida contra el
 * permiso `tenant.switch`. Sólo se agrega a requests de nuestro backend.
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenant = inject(TenantContextService);
  const config = inject(AppConfigService);

  const tenantId = tenant.tenantId();
  if (!tenantId) return next(req);

  const cfg = config.config();
  const isOwnApi =
    req.url.startsWith(cfg.apiBaseUrl) ||
    (cfg.apiFailoverUrl ? req.url.startsWith(cfg.apiFailoverUrl) : false);
  if (!isOwnApi) return next(req);

  const headers: Record<string, string> = { 'X-Tenant-Id': tenantId };
  if (tenant.isImpersonating()) {
    // Marca explícita de impersonación → el backend audita el override.
    headers['X-Acting-As-Tenant'] = tenantId;
  }

  return next(req.clone({ setHeaders: headers }));
};
